<template>
<div>
    <!-- Loading Overlay -->
    <div v-if="submitting" class="loading-overlay2">
        <div class="">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#52b2cf" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
            </svg>
        </div>
    </div>
    
    <!-- Header/Navigation -->
    <section class="simple-nav">
        <div class="simplenav_wrap">
            <div class="simplenav_flex">
                <div class="nav-left-div">
                    <a href="#" class="link-block w-inline-block"><img src="@/assets/images/OhMyMeds_Logo_w.svg" loading="lazy" alt="" class="image-545"></a>
                    <div class="nav-menu-links-div desk">
                        <div class="div-block-1129"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="nav-shadow"></div>
        <div class="mobile-nav-div">
            <div data-animation="default" data-collapse="medium" data-duration="400" data-easing="ease" data-easing2="ease" role="banner" class="navbar-mobile w-nav">
                <a href="#" class="brand home w-nav-brand"><img src="@/assets/images/OhMyMeds_Logo_w.svg" loading="lazy" alt="" class="image-551"></a>
                <div class="w-nav-overlay" data-wf-ignore="" id="w-nav-overlay-0"></div>
            </div>
            <div class="div-block-1958"></div>
        </div>
    </section>

    <!-- Getting Details Loading -->
    <div v-if="gettingDetails">
        <div class="dotted-loader"></div>
        <div class="h-80"></div>
    </div>
    
    <!-- Question Content -->
    <section class="section-7" style="justify-content: center;display: flex; margin-top:30px" v-else>
        <div class="questions-div setsizeonphone">
            <div class="question-content">
                <div class="question-container" v-if="currentQuestion">
                    <div class="question-div-2">
                        <div class="text-block-513" v-if="currentQuestion.question_type === 'dose_optimization'">Choose Dosage Schedule:</div>
                        <div class="text-block-513" v-else v-html="currentQuestion.label"></div>
                        
                        <div class="form-subs" v-if="currentQuestion.description && (currentQuestion.question_type !== 'dose_optimization')" v-html="currentQuestion.description"></div>
                        
                        <!-- Dose Optimization -->
                        <div class="w-form" v-if="currentQuestion.question_type === 'dose_optimization'">
                            <form>
                                <div class="dosage-drops-div">
                                    <div class="dose-sched-box" v-for="(month, index) in months.slice(0, 3)" :key="`month-${index}`">
                                        <div class="text-block-1241">{{ month }}</div>
                                        <select v-model="selectedDoses[index]" class="select-field-10 w-select">
                                            <option :value="null" disabled>{{ month }}</option>
                                            <option v-for="option in getDoseOptions(index)" :key="option.value" :value="option.value">
                                                {{ option.label }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <button type="button" class="form-button w-button balugabtn" @click="handleNext" :disabled="!canProceed">
                                    Next ->
                                </button>
                            </form>
                        </div>

                        <!-- File Upload -->
                        <div class="felix-form-block w-form" v-if="currentQuestion.question_type === 'image_upload'">
                            <div class="image-uploader">
                                <div class="upload-box" @dragover.prevent @drop.prevent="handleDrop" :class="{ 'drag-over': isDragging }" @dragenter.prevent="isDragging = true" @dragleave.prevent="isDragging = false">
                                    <input type="file" ref="fileInput" @change="handleFileChange" accept="image/*" class="file-input">
                                    <div class="upload-content">
                                        <div v-if="uploadLoading" class="loading">Processing...</div>

                                        <div v-else-if="uploadedFile" class="preview">
                                            <img :src="previewUrl" alt="Preview" v-if="previewUrl">
                                            <p class="file-info">{{ uploadedFile.name }} ({{ formatFileSize(uploadedFile.size) }})</p>
                                            <p class="upload-info">Click or drag to upload a new image</p>
                                        </div>

                                        <div v-else class="upload-prompt">
                                            <i class="upload-icon"><img src="@/assets/images/upload-icon.svg" style="height:25px"></i>
                                            <p>Drop image here or click to upload</p>
                                            <p class="file-size-info">Maximum file size: 5 MB</p>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="uploadError" class="error-message">
                                    {{ uploadError }}
                                    <div class="error-action">Please try uploading again</div>
                                </div>
                                <div v-if="uploading && uploadProgress > 0" class="upload-progress-container">
                                    <div class="upload-progress-bar">
                                        <div class="upload-progress-fill" :style="{ width: uploadProgress + '%' }"></div>
                                    </div>
                                    <div class="upload-progress-text">Uploading... {{ Math.round(uploadProgress) }}%</div>
                                </div>
                                <button class="form-button w-button balugabtn" :disabled="!uploadedFile || uploadLoading || uploading" :class="{ 'error-state': uploadError }" @click="confirmUpload">
                                    {{ uploadButtonText }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="enroll-form-back-link-div">
                    <a href="#" @click.prevent="goBack()" class="enroll-form-back-link w-inline-block" v-if="currentQuestionIndex > 0">
                        <div class="enroll-form-back-text">&lt; Go Back</div>
                    </a>
                </div>
            </div>
        </div>
    </section>
    <div style="height: 340px;"></div>
</div>
</template>

<script>
import { getProductById } from '@/utils/productData'
import { mapGetters } from 'vuex';

export default {
    name: 'AdjustDoses',
    props: [],
    data() {
        return {
            currentQuestionIndex: 0,
            answers: {},
            gettingDetails: true,
            submitting: false,
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            questions: [],
            productPurchased: '',
            months: [],
            selectedDoses: Array(3).fill(null),
            selectedDrug: null,
            maintanenceDose: 10,
            product_id : null,
            // Upload states
            uploadedFile: null,
            previewUrl: '',
            uploadError: '',
            uploadLoading: false,
            uploading: false,
            uploadProgress: 0,
            isDragging: false,
            maxFileSizeMB: 5,
            
            drugs: {
                semaglutide: [
                    { strength: 0.25, label: '0.25mg (Starting Dose)' },
                    { strength: 0.5, label: '0.5mg' },
                    { strength: 1.0, label: '1.0mg' },
                    { strength: 1.7, label: '1.7mg' },
                    { strength: 2.4, label: '2.4mg' }
                ],
                tirzepatide: [
                    { strength: 2.5, label: '2.5mg (Starting Dose)' },
                    { strength: 5.0, label: '5.0mg' },
                    { strength: 7.5, label: '7.5mg' },
                    { strength: 10.0, label: '10.0mg' },
                    { strength: 12.5, label: '12.5mg' },
                    { strength: 15.0, label: '15.0mg' }
                ]
            }
        }
    },

    computed: {
        ...mapGetters(['user']),
        
        currentQuestion() {
            return this.questions[this.currentQuestionIndex] || null
        },
        
        uploadButtonText() {
            if (this.uploading) return 'Uploading...'
            if (this.uploadError) return 'Try Again'
            return 'Confirm Upload'
        },

        maxFileSizeBytes() {
            return this.maxFileSizeMB * 1024 * 1024;
        },
        
        form_id() {
            return this.$route.params.id;
        },
        
        canProceed() {
            if (!this.currentQuestion) return false

            switch (this.currentQuestion.question_type) {
                case 'dose_optimization':
                    return this.selectedDoses.every(dose => dose !== null && dose !== undefined)
                case 'image_upload':
                    return !!this.answers[this.currentQuestion.id]
                default:
                    return true
            }
        }
    },

    created() {
        this.getOrder();
        this.initializeQuestions();
    },

    methods: {
        async getOrder() {
            try {
                // Make GET request to fetch order details
                const response = await this.$axios.get(`${this.baseUrl}/api/prescription-getorder/${this.$route.params.id}`);
                
                if (response.data && response.data.product_id) {
                    this.product_id=response.data.product_id;
                    const product = getProductById(response.data.product_id)[0];
                    this.productPurchased = product.name;
                    console.log(this.productPurchased)
                    // Initialize doses after product is set
                    this.initializeDosesForProduct();
                }
            } catch (error) {
                console.error('Error fetching order details:', error);
                // Fallback to existing logic
                const product = getProductById(this.product_id)[0];
                this.productPurchased = product.name;
            }
            
            this.months = ["Month 1", "Month 2", "Month 3"];
            this.selectedDoses = Array(3).fill(null);
            window.scrollTo(0, 0);
        },

        async initializeQuestions() {
            try {
                // Set the two specific questions as provided
                this.questions = [
                    {
                        "id": "1",
                        "question": "next_dose_option_optimization",
                        "label": "Customize Your Dosage Schedule:",
                        "description": "This is our recommended dosage based on the scenario above by feel free to customize (within dosing parameters)",
                        "question_type": "dose_optimization",
                        "important": false,
                        "is_critical": false,
                        "options": []
                    },
                    {
                        "id": "2",
                        "question": "prescription_photo",
                        "label": "Take a picture of your current prescription/medication",
                        "description": "<ol><li>Must include your name on the prescription</li><li>Without a picture, your doctor will not consider starting you at a higher dose</li></ol>",
                        "question_type": "image_upload",
                        "file_type": "other",
                        "important": false,
                        "is_critical": false
                    }
                ];
                
                // Initialize doses based on product
                this.initializeDosesForProduct();
                
                // Only set gettingDetails to false after everything is loaded
                this.gettingDetails = false;
                this.submitting = false;
            } catch (error) {
                console.error('Error initializing questions:', error);
                this.gettingDetails = false;
                this.submitting = false;
            }
        },

        initializeDosesForProduct() {
            // Set selected drug based on product name
            if (this.productPurchased) {
                this.selectedDrug = this.productPurchased.toLowerCase().includes('sema') ? 'semaglutide' : 'tirzepatide';
            }
        },
        
        getDoseOptions(monthIndex) {
            try {
                if (!this.selectedDrug || !this.drugs[this.selectedDrug]) {
                    return [];
                }
                const availableDoses = this.drugs[this.selectedDrug];

                // For first month, start from the beginning of available doses
                if (monthIndex === 0) {
                    return availableDoses.map(drug => ({
                        label: drug.label || `${drug.strength}mg`,
                        value: drug.strength
                    }));
                }

                // For subsequent months, show doses in increasing order based on previous month
                const prevDose = this.selectedDoses[monthIndex - 1];
                if (prevDose === null) return [];

                const currentIndex = availableDoses.findIndex(dose =>
                    Math.abs(dose.strength - prevDose) < 0.0001
                );

                if (currentIndex === -1) return [];

                const options = [];

                // Current dose (maintain)
                options.push(availableDoses[currentIndex]);

                // One step up if available (increase)
                if (currentIndex < availableDoses.length - 1) {
                    options.push(availableDoses[currentIndex + 1]);
                }

                // Two steps up if available (for more aggressive increase)
                if (currentIndex < availableDoses.length - 2) {
                    options.push(availableDoses[currentIndex + 2]);
                }

                return options.map(drug => ({
                    label: drug.label || `${drug.strength}mg`,
                    value: drug.strength
                }));
            } catch (error) {
                console.error('Error getting dose options:', error);
                return [];
            }
        },

        goBack() {
            if (this.currentQuestionIndex > 0) {
                // Clear current question's answer
                if (this.currentQuestion) {
                    this.$delete(this.answers, this.currentQuestion.id);
                    if (this.currentQuestion.question_type === 'dose_optimization') {
                        this.selectedDoses = Array(3).fill(null);
                    }
                }
                this.currentQuestionIndex--;
            }
        },

        handleNext() {
            if (!this.canProceed) return;
            
            if (this.currentQuestion.question_type === 'dose_optimization') {
                this.$set(this.answers, this.currentQuestion.id, this.selectedDoses);
            }
            
            this.moveToNextQuestion();
        },

        moveToNextQuestion() {
            // Simple logic: move to next question or submit if at the end
            if (this.currentQuestionIndex < this.questions.length - 1) {
                this.currentQuestionIndex++;
            } else {
                this.submitting = true;
                this.handleFinalSubmit();
            }
        },

        // File upload methods
        formatFileSize(bytes) {
            if (bytes === 0) return '0 Bytes'
            const k = 1024
            const sizes = ['Bytes', 'KB', 'MB', 'GB']
            const i = Math.floor(Math.log(bytes) / Math.log(k))
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
        },

        createPreviewUrl(file) {
            if (this.previewUrl) {
                URL.revokeObjectURL(this.previewUrl)
            }
            this.previewUrl = URL.createObjectURL(file)
        },

        async processUploadFile(file) {
            this.uploadError = ''
            this.uploadLoading = true
            this.uploadedFile = null
            this.previewUrl = ''

            try {
                if (!file) {
                    throw new Error('Please select a file')
                }

                if (!file.type.startsWith('image/')) {
                    throw new Error('Please upload an image file')
                }

                if (file.size > this.maxFileSizeBytes) {
                    throw new Error(`File size exceeds ${this.maxFileSizeMB} MB limit. Please choose a smaller file.`)
                }

                this.uploadedFile = file
                this.createPreviewUrl(file)

            } catch (err) {
                this.uploadError = err.message
                console.error('File processing error:', err)
            } finally {
                this.uploadLoading = false
            }
        },

        handleFileChange(event) {
            const file = event.target.files[0]
            if (file) {
                this.processUploadFile(file)
            }
        },

        handleDrop(event) {
            this.isDragging = false
            const file = event.dataTransfer.files[0]
            if (file) {
                this.processUploadFile(file)
            }
        },

        generateUniqueFilename(originalName) {
            const timestamp = new Date().getTime()
            const extension = originalName.split('.').pop()
            const nameWithoutExt = originalName.split('.').slice(0, -1).join('.')
            return `${this.form_id}_${this.currentQuestion.question}_${timestamp}_${nameWithoutExt}.${extension}`
        },

        async getSignedUrl(filename, contentType) {
            try {
                const response = await fetch(`${this.baseUrl}/api/get-signed-url`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        filename,
                        content_type: contentType
                    })
                })

                if (!response.ok) {
                    throw new Error('Failed to get signed URL')
                }

                return await response.json()
            } catch (error) {
                throw new Error('Error getting signed URL: ' + error.message)
            }
        },

        async uploadToS3(signedUrl, file) {
            try {
                return new Promise((resolve, reject) => {
                    const xhr = new XMLHttpRequest()

                    xhr.upload.addEventListener('progress', (event) => {
                        if (event.lengthComputable) {
                            this.uploadProgress = Math.round((event.loaded / event.total) * 100)
                        }
                    })

                    xhr.addEventListener('load', () => {
                        if (xhr.status >= 200 && xhr.status < 300) {
                            this.uploadProgress = 100
                            resolve()
                        } else {
                            reject(new Error('Failed to upload file to S3'))
                        }
                    })

                    xhr.addEventListener('error', () => {
                        reject(new Error('Network error during upload. Please check your internet connection.'))
                    })

                    xhr.open('PUT', signedUrl)
                    xhr.setRequestHeader('Content-Type', file.type)
                    xhr.send(file)
                })
            } catch (error) {
                throw new Error('Error uploading to S3: ' + error.message)
            }
        },

        async confirmUpload() {
            if (!this.uploadedFile || this.uploading) return

            this.uploading = true
            this.uploadError = ''
            this.uploadProgress = 0

            try {
                const filename = this.generateUniqueFilename(this.uploadedFile.name)
                const urlData = await this.getSignedUrl(filename, this.uploadedFile.type)
                if (!urlData?.url) {
                    throw new Error('Failed to get upload URL')
                }

                await this.uploadToS3(urlData.url, this.uploadedFile)
                await this.$nextTick()

                // Set answer and move to next question
                this.$set(this.answers, this.currentQuestion.id, filename)
                
                setTimeout(() => {
                    this.moveToNextQuestion()
                    this.resetUploadState()
                }, 500)

            } catch (err) {
                console.error('Upload error:', err)
                this.uploadError = 'The upload was unsuccessful. Please try again.'
            } finally {
                this.uploading = false
                this.uploadProgress = 0
            }
        },

        resetUploadState() {
            if (this.previewUrl) {
                URL.revokeObjectURL(this.previewUrl)
            }
            this.uploadedFile = null
            this.previewUrl = ''
            this.uploadError = ''
            this.uploadLoading = false
            this.uploading = false
            this.isDragging = false
            this.uploadProgress = 0
        },

        async handleFinalSubmit() {
            this.submitting = true;
            try {
                // Ensure doses are set for both products
                const hasEmptyDoses = this.selectedDoses.some(dose => dose === null || dose === undefined);
                if (hasEmptyDoses) {
                    if (this.productPurchased.toLowerCase().includes('tirze')) {
                        this.selectedDoses = [2.5, 5, 7.5];
                        this.maintanenceDose = 10;
                    } else {
                        this.selectedDoses = [0.25, 0.5, 1.0];
                        this.maintanenceDose = 2.4;
                    }
                }
            } catch (error) {
                console.log(error)
            }

            // Use single endpoint for form submission
            const endpoint = `https://webhooks.ohmymeds.com/api/submit-adjust-doses-form`;

            const submissionData = {
                ...this.formatAnswers(),
                form_id: this.$route.params.id,
                userInfo: this.user,
                paymentTerms: this.amountPaid,
                maintanenceDose: this.maintanenceDose,
                productPurchased: this.productPurchased,
                selectedDoses: this.selectedDoses,
                product_id: this.product_id,
                isRefil: false,
                formType: "adjustDose"
            };

            try {
                await this.$axios.post(endpoint, submissionData);
                this.submitting = false;
                this.$router.push('/home');
            } catch (error) {
                console.log(error)
                this.submitting = false;
            }
        },

        formatAnswers() {
            const images = [];

            // Process the prescription photo question
            if (this.answers['2']) {
                images.push({
                    question: 'prescription_photo',
                    answer: this.answers['2'],
                    type: 'image_upload',
                    description: 'Take a picture of your current prescription/medication',
                    important: false,
                    is_critical: false,
                    label: 'Take a picture of your current prescription/medication'
                });
            }

            return {
                answers: [],
                images: images,
                patientPreference: this.selectedDoses
            };
        }
    }
}
</script>

<style scoped>
.selected {
    background-color: #f0f0f0;
}

.file-upload-container {
    margin-bottom: 1rem;
}

.file-preview {
    margin-top: 1rem;
}

.image-preview {
    max-width: 200px;
    max-height: 200px;
    object-fit: contain;
}

.file-name {
    margin-top: 0.5rem;
    font-size: 0.9rem;
    color: #666;
}

.next-button-enabled {
    opacity: 1;
    cursor: pointer;
}

.next-button-enabled:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.info-message {
    padding: 1rem;
    background-color: #f8f9fa;
    border-radius: 4px;
    margin-bottom: 1rem;
}

.checkbox-field-15 {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
}

.checkbox-11 {
    margin-right: 0.5rem;
}

.acceptbutton {
    background-color: var(--light-green) !important;
    border: none;
    color: #fff
}

.rejectconbutton {
    background-color: transparent !important;
    height: 20px;
    border: none;
    text-align: center;
    justify-content: center;
}

.rejectconbutton .text-block-545 {
    font-size: 12px !important;
}

.dose-sched-box {
    width: 32%;
    padding: 10px 2px;
}

.select-field-10 {
    width: 72%;
}

@media (max-width: 768px) {
    .setsizeonphone {
        max-width: 100%;
        padding-right: 10px;
        padding-left: 10px;
    }
}

@media screen and (max-width: 479px) {
    .dose-sched-box.solo {
        width: 100%;
    }
}

.image-uploader {
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
}

.upload-box {
    position: relative;
    border: 2px dashed #ccc;
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-bottom: 15px;
}

.upload-box:hover {
    border-color: #666;
}

.drag-over {
    border-color: #2196F3;
    background-color: rgba(33, 150, 243, 0.1);
}

.file-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
}

.upload-content {
    padding: 20px;
}

.upload-icon {
    font-size: 48px;
    margin-bottom: 10px;
}

.upload-prompt p {
    margin: 10px 0;
    font-size: 16px;
    color: #666;
}

.file-size-info {
    font-size: 14px;
    color: #999;
    margin-top: 5px;
}

.file-info {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    margin: 5px 0;
}

.upload-info {
    font-size: 14px;
    color: #999;
}

.preview {
    margin: 10px 0;
}

.preview img {
    max-width: 100%;
    max-height: 300px;
    border-radius: 4px;
    margin-bottom: 10px;
}

.loading {
    padding: 20px;
    color: #666;
}

.error-message {
    color: #f44336;
    margin-top: 10px;
    font-size: 14px;
    padding: 10px;
    background-color: #ffebee;
    border-radius: 4px;
    border: 1px solid #ffcdd2;
}

.error-action {
    margin-top: 5px;
    font-weight: 500;
}

.error-state {
    background-color: #f44336 !important;
    border-color: #d32f2f !important;
}

.error-state:hover {
    background-color: #d32f2f !important;
}

/* Upload Progress Bar Styles */
.upload-progress-container {
    margin-bottom: 15px;
}

.upload-progress-bar {
    width: 100%;
    height: 8px;
    background-color: #f0f0f0;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 8px;
}

.upload-progress-fill {
    height: 100%;
    background: linear-gradient(90deg, #2196F3, #21CBF3);
    transition: width 0.3s ease;
    border-radius: 4px;
}

.upload-progress-text {
    text-align: center;
    font-size: 14px;
    color: #666;
    font-weight: 500;
}
</style>